/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { loopSchema } from './loopSchema';

export const loopPaginationResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(loopSchema);
  },
  recordCount: z.int(),
  recordLimit: z.int(),
});
